export default [
  {path: '/zmlapp/:html', name: '脂玫乐APP', component: () => import('@/view/zmlApp/zmlapp'), meta: {title: '脂玫乐APP', }, },
  {path: '/about/:html', name: '联系我们', component: () => import('@/view/about/about'), meta: {title: '联系我们', }, },
];



// WEBPACK FOOTER //
// src/router/about.js